import { useState } from "react";
import { AdStatus, VerifyModalI } from "../../../../../models";
import { mapModuleToHr } from "../../../../../routes/LanguageMapper";
import { checkEmptyObject } from "../../../../../services";
import confirmModal from "../../../../../services/confirmModal";
import { getVerifyModalContent } from "../../../../../services/getVerifyModalContent";
import { StaticHTML } from "../../../../../components";
import ReactGA from "react-ga4";
import history from "../../../../../history";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../../../../routes/Auth/auth.ducks";
import React from "react";

const blankVerifyModal: VerifyModalI = {
  heading: "",
  content: "",
  redirectPath: ""
};


export const useAdActions = (props) => {
  const {
    ad,
    onEdit,
    onDelete,
    onActive,
    onPaused,
    onSold,
    onPromote,
    onRenew,
    onAwaitingPayment,
    onAutoPromotionEnable,
    onAutoPromotionDisable,
    gaCategory,
  } = props;
  const gaEventCategory = gaCategory || "Moji oglasi";
  const user = useSelector(selectUserInfo)

  const [verifyModal, setVerifyModal] = useState(blankVerifyModal);


  const preventDefaultClick = (event: any) => {
    if (!event) {
      return;
    }

    event.preventDefault();
  };

  const adActions = {
    onEdit: (e: any) => {
      preventDefaultClick(e);
      ReactGA.event({
        category: gaEventCategory,
        action: "click",
        label: "Izmjena oglasa"
      });
      confirmModal.show({
        title: "Uredi oglas",
        okText: "U redu",
        cancelText: "Otkaži",
        iconType: "NaN",
        onOk() {
          onEdit(ad.id, mapModuleToHr(ad.module));
        },
        children: "Jeste li sigurni da želite urediti oglas?"
      });
    },
    onDelete: (e: any) => {
      preventDefaultClick(e);
      ReactGA.event({
        category: gaEventCategory,
        action: "click",
        label: "Brisanje oglasa"
      });
      confirmModal.show({
        title: "Obriši oglas",
        okText: "Obriši oglas",
        cancelText: ad.status === AdStatus.sold ? "Otkaži" : "Uredi oglas",
        iconType: "NaN",
        onOk() {
          onDelete(ad.id);
        },
        onCancel: (e, isCancelledOnXClick) => {
          if (!isCancelledOnXClick && ad.status !== AdStatus.sold) {
            onEdit(ad.id, mapModuleToHr(ad.module));
          }
        },
        children: ad.status === AdStatus.sold ?
          "Jeste li sigurni da želite izbrisati oglas?" :
          (<div>
            <p>Želite li zaista obrisati oglas ili ga želite izmijeniti?
            </ p >
            <p>
              Ako želite promijeniti cijenu, slike ili opis, možete urediti postojeći oglas bez brisanja.
            </p>
          </div>)
      });
    },
    onActive: (e: any) => {
      preventDefaultClick(e);
      ReactGA.event({
        category: gaEventCategory,
        action: "click",
        label: "Aktivacija oglasa"
      });

      if (checkEmptyObject(user) && user.isVerified && !user.hasInvalidUsername) {
        confirmModal.show({
          title:
            ad.status === AdStatus.sold
              ? "Reaktiviraj oglas"
              : "Aktiviraj oglas",
          okText: "U redu",
          cancelText: "Otkaži",
          iconType: "NaN",
          onOk() {
            onActive(ad.id);
          },
          children:
            ad.status === AdStatus.sold
              ? "Jeste li sigurni da želite reaktivirati oglas?"
              : "Jeste li sigurni da želite aktivirati oglas?"
        });
      }
      else {
        setVerifyModal(getVerifyModalContent(user));
      }
    },
    onRenew: (e: any) => {
      preventDefaultClick(e);
      ReactGA.event({
        category: gaEventCategory,
        action: "click",
        label: "Obnova oglasa"
      });

      if (checkEmptyObject(user) && user.isVerified && !user.hasInvalidUsername) {
        confirmModal.show({
          title: "Obnovi oglas",
          okText: "U redu",
          cancelText: "Otkaži",
          iconType: "NaN",
          onOk() {
            onRenew(ad.id);
          },
          children: "Jeste li sigurni da želite obnoviti oglas?"
        });
      }
      else {
        setVerifyModal(getVerifyModalContent(user));
      }
    },
    onPaused: (e: any) => {
      preventDefaultClick(e);
      ReactGA.event({
        category: gaEventCategory,
        action: "click",
        label: "Pauziranje oglasa"
      });
      confirmModal.show({
        title: "Pauziraj oglas",
        okText: "U redu",
        cancelText: "Otkaži",
        iconType: "NaN",
        onOk() {
          onPaused(ad.id);
        },
        children: "Jeste li sigurni da želite pauzirati oglas?"
      });
    },
    onSold: (e: any) => {
      preventDefaultClick(e);
      ReactGA.event({
        category: gaEventCategory,
        action: "click",
        label: "Prodan oglas"
      });
      confirmModal.show({
        title: "Označite oglas kao prodan",
        okText: "U redu",
        cancelText: "Otkaži",
        iconType: "NaN",
        onOk() {
          onSold(ad.id);
        },
        children: "Jeste li sigurni da želite označiti oglas kao prodan?"
      });
    },
    onPromote: (e: any) => {
      preventDefaultClick(e);
      ReactGA.event({
        category: "Promocija oglasa",
        action: "Click",
        label: "Klik na button na Moji oglasi"
      });

      confirmModal.show({
        title: "Istaknite oglas",
        okText: "Istakni oglas",
        cancelText: "Odustani",
        iconType: "NaN",
        onOk: () => {
          ReactGA.event({
            category: "Promocija oglasa",
            action: "Click",
            label: "Aktivacija u modalu"
          });
          onPromote(ad.id);
        },
        onCancel: () => {
          ReactGA.event({
            category: "Promocija oglasa",
            action: "Click",
            label: "Odustajanje u modalu"
          });
        },
        children: ad.searchPagePosition === 1 ? "Jeste li sigurni da želite istaknuti oglas?"
          : <span><strong>Vaš oglas je trenutno na {ad.searchPagePosition}.stranici.</strong> <br /> Isticanjem će se prikazivati na prvoj stranici, iznad ostalih oglasa u kategoriji.</span>
      });
    },
    onAutoPromottionEnable: (e: any) => {
      preventDefaultClick(e);
      confirmModal.show({
        title: "Aktiviraj automatsko reisticanje",
        okText: "Aktiviraj",
        cancelText: "Ne želim",
        iconType: "NaN",
        onOk() {
          onAutoPromotionEnable(ad.id);
        },
        children: <StaticHTML content={"Aktiviraj automatsko reisticanje oglasa, i tvoj oglas će se, nakon isteka promocije, ponovno podići na vrh pretrage sve dok ne isključiš ovu opciju ili dok ne ostaneš bez kredita.".replaceAll("{0}", "<br />")} />
      });
    },
    onAutoPromotionDisable: (e: any) => {
      preventDefaultClick(e);
      confirmModal.show({
        title: "Deaktiviraj automatsko reisticanje",
        okText: "Deaktiviraj reisticanje",
        cancelText: "Nastavi reisticanje",
        iconType: "NaN",
        onOk() {
          onAutoPromotionDisable(ad.id);
        },
        children: <StaticHTML content={"Trenutno imate uključeno automatsko reisticanje oglasa, koje omogućuje da se vaši oglasi automatski podižu na vrh pretraživanja nakon isteka promocije.{0}{0}Želite li isključiti ovu opciju? Nakon isključivanja, vaš oglas više neće biti automatski reistaknut.".replaceAll("{0}", "<br />")} />
      });
    },
    onAwaitingPayment: (e: any) => {
      preventDefaultClick(e);
      onAwaitingPayment();
    }
  }

  return {
    adActions,
    verifyModal,
    setVerifyModal,
    blankVerifyModal

  }
}



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/hooks/useAdActions.tsx